import {
  WHEEL_SUPPLY_ALL,
  WHEEL_SUPPLY_GET,
  WHEEL_SUPPLY_POST,
  WHEEL_SUPPLY_PUT,
  WHEEL_SUPPLY_DELETE,
  WHEEL_SUPPLY_LOADING,
  WHEEL_SUPPLY_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const wheelSupplyCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_SUPPLY_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/wheel-supply`,
      {
        ...payload,
      },
    );
    dispatch({ type: WHEEL_SUPPLY_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_SUPPLY_ERROR });
  }
};

export const wheelSupplyAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/wheel-supply?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: WHEEL_SUPPLY_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_SUPPLY_ERROR });
  }
};

export const wheelSupplyGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/wheel-supply/${id}`,
    );
    if (status === 200) {
      dispatch({ type: WHEEL_SUPPLY_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_SUPPLY_ERROR });
  }
};

export const wheelSupplyPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_SUPPLY_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/wheel-supply/${id}`,
      payload,
    );
    dispatch({ type: WHEEL_SUPPLY_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_SUPPLY_ERROR });
  }
};
export const wheelSupplyDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_SUPPLY_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/wheel-supply/${id}`,
    );
    dispatch({ type: WHEEL_SUPPLY_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_SUPPLY_ERROR });
  }
};
